<template>
  <dialog-add
    icon="group"
    :title="$t('new_advertiser')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-tracking-add-new-advertiser
        :on-cancel="onCancel"
        class="elevation-1"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/tracking-management');
    },
  },
};
</script>
